export default "__VITE_ASSET__BsFjja_0__"